export const environment = {
  production: true,
  host: {
    base: 'https://handbook-multi-tenant-app-prod.azurewebsites.net',
  },
};
